import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Link as MuiLink,
  IconButton
} from '@mui/material';
import FileInput from "../Shared/FileUploadPreview/FileInput";
import { useSnackBar } from "../FlowBuilder/Common/SnackBar/index.tsx";
import DynamicBreadcrumbs from "../Shared/Breadcrumb/index.tsx";
import { useNavigate } from "react-router";
import HomeIcon from '@mui/icons-material/Home';


const MAX_IMAGE_SIZE = 2 * 1024 * 1024;
const MAX_VIDEO_SIZE = 20 * 1024 * 1024;
const MAX_DOCUMENT_SIZE = 5 * 1024 * 1024;


const PdfScrapping = () => {
  const [file, setFile] = useState<File | null>(null);
  const [url, setUrl] = useState<string>('');
  const { showSnackBar } = useSnackBar();
  const navigate = useNavigate();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (!selectedFile) return;

    if (selectedFile.type.startsWith('image') && selectedFile.size > MAX_IMAGE_SIZE) {
      showSnackBar("Image files must be smaller than 2 MB.", "error");
      return;
    }

    if (selectedFile.type.startsWith('video') && selectedFile.size > MAX_VIDEO_SIZE) {
      showSnackBar("Video files must be smaller than 20 MB.", "error");
      return;
    }

    if (
      !selectedFile.type.startsWith('image') &&
      !selectedFile.type.startsWith('video') &&
      selectedFile.size > MAX_DOCUMENT_SIZE
    ) {
      showSnackBar("Document files must be smaller than 5 MB.", "error");
      return;
    }

    const validTypes = ['image/jpeg', 'image/png', 'video/mp4', 'application/pdf'];
    if (!validTypes.includes(selectedFile.type)) {
      showSnackBar("Invalid file type. Accepted types are JPEG, PNG, MP4, and PDF.", "error");
      return;
    }

    setFile(selectedFile);
  };

  const handleUpload = async () => {
    if (!file) {
      console.log("Please select a file to upload.", "error");
      return;
    }

    const my_filename = `${Date.now().toString()}${file.name}`.replace(/ /g, '_');
    const updatedFile = new File([file], my_filename, { type: file.type });
  };

  const breadcrumbsData = [
    {
      label: <IconButton color="primary"><HomeIcon /></IconButton>,
      onClick: () => navigate('/')
    },
    { label: "Tools", onClick: () => navigate('/r/tools') },
    { label: 'PDF Scrapping' }
  ]
  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
      <DynamicBreadcrumbs
        items={breadcrumbsData}
        onBreadcrumbClick={(e, item) => item?.onClick?.()}
      />

      <div className="p-4">
        {/* <Typography variant="h4">PDF Scrapping Page</Typography> */}
        <Grid fluid className="d-flex vh-50 style-file-upload">
          <Grid container justifyContent="center">
            <Grid item xs={12} md={6} sx={{justifyItems:'center'}}>
              <Card elevation={3} sx={{width:"40%"}}>
                <CardContent sx={{paddingTop:"18px"}}>
                  <Typography variant="h6" gutterBottom>
                    Upload a File
                  </Typography>

                  <Box mt={2}>
                    <FileInput 
                      onFileSelect={handleFileChange} 
                      onFileRemove={() => setFile(null)}
                      onFileUpload={handleUpload}
                      file={file}
                      accept="image/jpeg, image/png, video/mp4, application/pdf"
                    />
                  </Box>

                  {url && (
                    <Box mt={3}>
                      <Typography variant="body2" color="success.main">
                        File uploaded successfully!
                      </Typography>
                      <Box mt={1}>
                        <MuiLink
                          component="button"
                          variant="body2"
                          onClick={() => navigator.clipboard.writeText(url)}
                          sx={{ mr: 2 }}
                        >
                          Copy URL
                        </MuiLink>
                        <MuiLink href={url} target="_blank" rel="noopener">
                          Open Uploaded File
                        </MuiLink>
                      </Box>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>

          </Grid>
        </Grid>
      </div>
    </Box>
  );
};

export default PdfScrapping;


